(function (window, document) {

  const init = () => {
    const updateLocationHash = (hash) => {
      history.pushState({}, "", hash);
    };

    const checkOnLoad = () => {
      const locationHash = window.location.href.split('#')[1];

      if (
        locationHash === null || 
        locationHash === undefined ||
        locationHash === ''
      ) return false;
      
      const targetLocation = document.querySelector(`#${locationHash}`);

      if (targetLocation !== null && targetLocation !== undefined) {
        targetLocation.scrollIntoView();
      }
    };

    const initOnClick = () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const elementId = this.getAttribute('href');

          document.querySelector(elementId).scrollIntoView({
            behavior: 'smooth'
          });

          updateLocationHash(elementId);
        });
      });
    };

    const initAll = () => {
      initOnClick();
      checkOnLoad();
    };

    initAll();
  };

  document.addEventListener("DOMContentLoaded", init);

})(window, window.document);